var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Select Device")]),_c('b-btn-group',_vm._l((_vm.selectableDevices),function(device){return _c('b-button',{key:device.id,attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.handleDeviceClick(device.id)}}},[_vm._v(" "+_vm._s(_vm.labelFromDevice(device))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }